import React, { Component } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./AboutUs.css";
import Navbar from "../Navbar/Navbaranim";
import Mentors from "./Mentors/Mentors";
import TeamMembers from "./TeamMembers/TeamMembers";
import CompanyProfile from "./CompanyProfile/CompanyProfile";
import Main from "./Main/Main";
import Textbanner from "./TextBanner/TextBanner";
import ContactUs from "./ContactUs/Contactus";
import ContactUsMob from "../ContactUs/Contactus";
import Footer from "../Footer/Footer";
import { Dimensions } from "../Helper/sitedimension";

const AboutUsPage = () => {
  const { width } = Dimensions.useWindowDimensions();
  return (
    <div className="AboutUsPage">
      <Navbar className="navbar" />
      <Main className="main" />
      <CompanyProfile className="companyprofile" />
      <TeamMembers className="teamMember" />
      {/* {width > 500 ? <Mentors className="mentorsabout" /> : null} */}
      <Textbanner className="textBanner" />
      {width > 500 ? (
        <ContactUs className="contactus2" />
      ) : (
        <ContactUsMob className="conmobile" />
      )}
      {width > 500 ? (
        <Footer className="footer" />
      ) : (
        <Footer className="footerab" />
      )}
    </div>
  );
};

export default AboutUsPage;
